const DEFAULT_LEGAL_URL = 'https://cash.app/legal/tos'
const STATUS_PAGE_URL = 'https://status.cash.app'
const CASH_APP_URL = 'https://cash.app'
const CONTACT_URL = '/contact'
interface FooterLink {
  [key: string]: string
}

// if you're adding more links, make sure you add equivalent titles in /locales/<lang>/translations.js
export const getFooterLinks = (region: string): FooterLink => {
  switch (region) {
    case 'US':
      return {
        cashApp: CASH_APP_URL,
        contact: CONTACT_URL,
        status: STATUS_PAGE_URL,
        security: '/security',
        legal: 'https://cash.app/legal/tos',
      }
    case 'GB':
      return {
        cashApp: CASH_APP_URL,
        contact: CONTACT_URL,
        status: STATUS_PAGE_URL,
        legal: 'https://squareup.com/gb/legal/cash-ua',
      }
    case 'IE':
      return {
        cashApp: CASH_APP_URL,
        contact: CONTACT_URL,
        status: STATUS_PAGE_URL,
        legal: 'https://cash.app/legal/ie/en-ie/tos',
      }
    case 'CA':
    default:
      return {
        cashApp: CASH_APP_URL,
        contact: CONTACT_URL,
        status: STATUS_PAGE_URL,
        legal: DEFAULT_LEGAL_URL,
      }
  }
}
